import { Component, Injectable, Input, Output, EventEmitter } from '@angular/core';
export interface myData {
}
@Injectable()
export class SharedData {
    public sharingData: myData = {};
    public sharingArrayData: any = [];
    public nextPageData: any;
    public currentPageData: any;
    public perviousPageData: any;
    public map = new Map();


    saveData(str) {
        this.sharingData = str;
    }

    getData() {
        return this.sharingData;
    }

    saveArray(str) {
        this.sharingArrayData = str;
    }
    getArray() {
        return this.sharingArrayData;
    }
    getNextPageData(data) {
        this.nextPageData = data;
    }
    getCurrentPageData(data) {
        this.nextPageData = data;
    }
    getPerviousPageData(data) {
        this.nextPageData = data;
    }

    saveAsMap(key, value) {
        this.map.set(key, value)
    }

    getMapValues(key) {
        return this.map.get(key);
    }

    public clear() {
        return this.map = new Map();
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/sharedData.ts